import { hasSelectedFacets, getSort } from "./modules/search";
import isFacetedNavPage from "./modules/category/selectors/isFacetedNavPage";
import { getLocation } from "../state/modules/router/selectors";

export const shouldRenderPagination = state => {
  const location = getLocation(state);
  const isCtaUrl = !!location.pathname.includes("ctas");

  return (
    !isCtaUrl &&
    (isFacetedNavPage(state) || !hasSelectedFacets(state)) &&
    !getSort(state)
  );
};
